<template>
  <div class="row cards-layout">
    <div
      v-for="item in items"
      :key="entityKey(item)"
      v-show="showItem(item)"
      :class="gridClass"
    >
      <competency-mark-card
        :item="item"
        :score="item.score"
        :userID="userID"
        :type="type"
        :typeSkill="typeSkill"
        :canChangeEntities="canChangeEntities"
        :isAdmin="isAdmin"
        @goTo="goToCategory(item)"
        @selectMark="selectMark(item)"
        @reloadObj="reloadObj" 
        @saveManageAssigment="saveManageAssigment" 
        @delFile="delFile" 
      />
      <v-col v-if="isAdmin" class="edit-mark-card">
        <v-btn
          class="edit-field-button dark-icon-btn"
          title="Редактировать"
          variant="text"
          text
          @click="openEntityEditor(item)"
        >
          <v-icon>mdi-pencil-outline</v-icon>
        </v-btn>

        <v-btn
          class="delete-field-button dark-icon-btn"
          title="Удалить"
          variant="text"
          text
          @click="delEntity(item)"
        >
          <v-icon>mdi-trash-can-outline</v-icon>
        </v-btn>
      </v-col>
    </div>

  </div>
</template>

<script>
import CompetencyMarkCard from "@/components/Cards/CompetencyMarkCard";

export default {
  name: "Categories",

  components: {
    CompetencyMarkCard
  },

  props: {
    itemsCategory: {
      type: Array,
      default: () => []
    },
    canChangeEntities: {
      type: Boolean,
      default: false
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ""
    },
    typeSkill: {
      type: String,
      default: ""
    },
    customHard: {
      type: Array,
      default: () => []
    },
    customSoft: {
      type: Array,
      default: () => []
    },
    userID: {
      type: [Number, String],
      default: 0
    }
  },

  data() {
    return {
      items: []
    };
  },

  computed: {
    isAdminWithUser() {
      return this.canChangeEntities && !!this.userID;
    },
    isAdminWithoutUser() {
      return this.canChangeEntities && !this.userID;
    },

    // классы сетки
    gridClass() {
      if (this.type === "tasks") {
        return "mark-card mark-card-question col-12";
      } else if (this.type === "questions") {
        return "mark-card mark-card-question col-12 col-xl-6";
      }
      return "mark-card col-12 col-sm-6 col-xl-4";
    },

  },

  mounted() {
    this.initItemsFromCategory();
  },

  watch: {
    // если прилетят новые данные или сменится тип – пересчитаем items
    itemsCategory: {
      handler() {
        this.initItemsFromCategory();
      },
      deep: true
    },
    type() {
      this.initItemsFromCategory();
    }
  },

  methods: {
    entityKey(entity) {
      // небольшая защита от отсутствия id
      return entity.id || `${entity.type || "e"}-${entity.path || Math.random()}`;
    },

    initItemsFromCategory() {
      const src = this.itemsCategory;

      if (!src || !src.length) {
        this.items = [];
        return;
      }

      const type = this.type;

      let result = [];

      if (type === "tasks") {
        result = src.filter((i) => i.type === "task");
      }
      else if (type === "questions") {
        result = src.filter((i) => i.type === "question");
      }
      else {
        result = src.filter((i) => i.type !== "task" && i.type !== "question");
      }

      this.items = result;
    },

    goToCategory(item) {
      if (this.type === "areas") {
        // this.$root.$globalType.skill = this.typeSkill;
        this.$store.commit("setGlobalSkill", this.typeSkill);
      }

      const route = this.$route;

      // Родители текущей страницы
      const parents = route.name === "areasLayout"
        ? []
        : (route.params.parents || []);

      const currentId = route.params.id;
      const currentType = route.name; // area, competency, theme, subtopic

      const newParents = currentId
        ? [...parents, { id: currentId, type: currentType }]
        : parents;

      this.$router.push({
        name: item.type,
        params: {
          id: item.id,
          parents: newParents
        },
        query: route.query
      });

    },

    selectMark(item) {
      this.$emit("selectMark", item);
    },

    openEntityEditor(item) {
      item.typeSkill = this.typeSkill;

      this.$emit("openEditor", item);
    },

    delEntity(item) {
      this.$emit("delEntity", item);
    },

    showItem(item) {
      return !!(item && item.viewerRights && item.viewerRights.canView)
    },

    reloadObj(res) {
      this.$emit("reloadObj", res);
    },
    saveManageAssigment(res) {
      this.$emit("saveManageAssigment", res);
    },

    delFile(payload) {
      this.$emit("delFile", payload);
    },

  }
};
</script>

<style scoped>
</style>
